import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { getBrand, getBrandConfig, getEnvironment, initializeSentry } from '@shared/services';
import { AppComponent } from 'src/app/app.component';
import { appConfig } from 'src/app/app.config';

import packageInfo from '../package.json';

initializeSentry('capture-send@' + packageInfo.version);

// Apply the host-based default brand before bootstrap (per-workflow branding, when
// present, still overrides this at runtime via ThemeService).
const brandConfig = getBrandConfig();
document.documentElement.setAttribute('data-brand', getBrand());
document.querySelector<HTMLLinkElement>('link[rel="icon"]')?.setAttribute('href', brandConfig.favicon);
document.title = brandConfig.displayName;

if (getEnvironment().production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
